import {IPlacesAddressFormValue} from "../types/IPlacesAddressFormValue";
import {stripPostalCodeFromAddress} from "./strip_postal_code_from_address";

export const createEmptyPlacesAddressFormValue = (): IPlacesAddressFormValue => ({
    city: "",
    label: "",
    lat: null,
    lon: null,
    street: "",
    streetNumber: "",
    value: ""
});

export const createPlacesAddressFormValueFromLabel = (label: string | null | undefined): IPlacesAddressFormValue => ({
    ...createEmptyPlacesAddressFormValue(),
    label: stripPostalCodeFromAddress(label?.trim() ?? "")
});

export const getPlacesAddressLabel = (value: IPlacesAddressFormValue | null | undefined): string => stripPostalCodeFromAddress(value?.label?.trim() ?? "");

export const getPlacesAddressInputValue = (value: IPlacesAddressFormValue | null | undefined): string => {
    const label = getPlacesAddressLabel(value);

    if (!label || !value?.street?.trim() || value.streetNumber?.trim()) return label;

    return `${label} `;
};
import {IPlacesAddressFormValue} from "../types/IPlacesAddressFormValue";
import {stripPostalCodeFromAddress} from "./strip_postal_code_from_address";

export const createEmptyPlacesAddressFormValue = (): IPlacesAddressFormValue => ({
    city: "",
    label: "",
    lat: null,
    lon: null,
    street: "",
    streetNumber: "",
    value: ""
});

export const createPlacesAddressFormValueFromLabel = (label: string | null | undefined): IPlacesAddressFormValue => ({
    ...createEmptyPlacesAddressFormValue(),
    label: stripPostalCodeFromAddress(label?.trim() ?? "")
});

export const getPlacesAddressLabel = (value: IPlacesAddressFormValue | null | undefined): string => stripPostalCodeFromAddress(value?.label?.trim() ?? "");

export const getPlacesAddressInputValue = (value: IPlacesAddressFormValue | null | undefined): string => {
    const label = getPlacesAddressLabel(value);

    if (!label || !value?.street?.trim() || value.streetNumber?.trim()) return label;

    return `${label} `;
};
